import AsanaCustomFields from "../Asana/AsanaCustomFields";
import ServiceNowCustomFields from "../serviceNow/ServiceNowCustomFields";

export const RENDER_FIELDS_V2 = {
  "Service Now": ServiceNowCustomFields,
  Asana: AsanaCustomFields,
};
